import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import ProofBand from './components/ProofBand';
import Events from './components/Events';
import Differentials from './components/Differentials';
import Testimonials from './components/Testimonials';
import Packages from './components/Packages';
import HowItWorks from './components/HowItWorks';
import FAQ from './components/FAQ';
import QuoteForm from './components/QuoteForm';
import Footer from './components/Footer';
import StickyCTA from './components/StickyCTA';
import DiscoBall from './components/DiscoBall';
import SoundToggle from './components/SoundToggle';

// Ordem: oferta → prova → para quem → por que o Paulo → quem já contratou →
// preço → como funciona → objeções → ação.
function App() {
  return (
    <div className="min-h-[100dvh] bg-page text-ink">
      <DiscoBall />
      <Header />
      <main className="relative z-10">
        <Hero />
        <ProofBand />
        <Events />
        <Differentials />
        <Testimonials />
        <Packages />
        <HowItWorks />
        <FAQ />
        <QuoteForm />
      </main>
      <div className="relative z-10">
        <Footer />
      </div>
      <SoundToggle />
      <StickyCTA />
    </div>
  );
}

export default App;
